<template>
    <div class="d-flex flex-column flex-start justify-content-start microsoft-autenticator">
        <b-form @submit="submit" id="form-login-second-step">
            <p class="hint mb-4">Insira o Código de Senha de Uso Único fornecido no Microsoft Authenticator</p>
            <b-form-group label-for="Token">
                <b-form-input id="tokenEmail__" placeholder="Digite o código aqui" :state="tokenState" v-model="token" maxlength="6" trim />
                <b-form-invalid-feedback :state="tokenState">{{validation.token}}</b-form-invalid-feedback>
            </b-form-group>
            <div class="d-flex justify-content-end mt-2">
                <b-button pill @click="cancelar" class="btn-base outline-primary-btn mr-2">Voltar</b-button> 
                <b-button pill type="submit" class="btn-base primary-btn">Entrar</b-button>      
            </div>
            <div class="d-flex justify-content-end mt-4">
                <p class="btn-auth-type" @click="changeTypeAuth()">Tentar de outra maneira</p>
            </div>
          </b-form>

          <div class="mt-2 mb-4"  v-if="qrcodeUrl">
            <p class="info-text mb-3" style="font-weight:bold">Precisa de ajuda? Siga o passo a passo:</p>
            <p class="info-text mb-3">1º Passo: Comece obtendo o aplicativo <br/>Em seu telefone, instale o aplicativo Microsoft Authenticator. <a href="https://www.microsoft.com/pt-br/security/mobile-authenticator-app" target="_blank">Baixar agora</a>.
            <br/>Depois de instalar o aplicativo Microsoft Authenticator em seu dispositivo, selecione "Avançar".</p>
            <p class="info-text mb-3">2º Passo: Configure a sua conta <br/>Se for solicitado, permita as notificações. Em seguida, adicione uma conta e selecione "Empresa ou escola".</p>
            <p class="info-text mb-3">3º Passo: Verifique o código QR <br/>Use o aplicativo Microsoft Authenticator para ler o código QR, isso conecta o aplicativo Microsoft Authenticator a sua conta. Depois de examinar o código QR selecione "Avançar".</p>
            <div class="d-flex justify-content-center mb-2 mt-4">
                <QRCode :value="qrcodeUrl" :size="250" level="H" background="#ffffff" foreground="#000000" />
            </div>
            <div class="d-flex flex-column align-items-center mb-2 mt-4">
                <p class="info-account mb-2">Nome da conta: {{ totp.account }} </p>
                <b-button pill @click="copyToClipboard(totp.account)" class="btn-base outline-primary-btn mr-2 mb-2">Copiar</b-button> 
                <p class="info-account mb-2">Chave secreta: {{ totp.secret }}</p>
                <b-button pill @click="copyToClipboard(totp.secret)" class="btn-base outline-primary-btn mr-2 mb-2">Copiar</b-button> 
            </div>
        </div>
    </div>
</template>

<script>
import Validations from "@/util/Validations"
import LoginResource from "@/resources/LoginResource"
import QRCode from 'qrcode.vue';
import { TOTP } from "@/util/utils"

export default {
	name: "App",
    components: {
        QRCode
    },
    data() {
        return {
            token: null,
            totp: {
                account: null,
                secret: null 
            },
            qrcodeUrl: null,
            startKeyUp: null,
            validation : {
                token: null
            }
        }
    },
    computed: {
        tokenState() {
        return this.validation.token ? false : null
      }
    },
    methods: {
        submit (event) {   
            event.preventDefault();
            this.validation = {}
            this.validation.token = !this.token ? "Este campo é obrigatório!" : null
    
            if (!Validations.isEmpty(this.validation)) {
                return
            }
    
            LoginResource.loginSecondStepByTotp(parseInt(this.token), {context: "login", showLoader: true, showValidationAlert: true})
            .then(response => {
                this.$emit("save-auth-tokens", response)
            })
        },
        cancelar() {
            this.$emit("clear-logged-user")
        },
        changeTypeAuth()
        {
            this.$emit("change-auth-type", TOTP)
        },
        setTotp(url) {
            const regex = /otpauth:\/\/totp\/[^:]+:([^?]+)\?secret=([^&]+)&issuer=/;
            const match = url.match(regex);
            if (match) {
                const account = match[1];
                const secret = match[2];
                this.totp = { account, secret };
            }
        },
        copyToClipboard(value) {
            navigator.clipboard.writeText(value)
        },
        handleKeyupEnter(event) {
        if(!this.startKeyUp) {
            this.startKeyUp = true
            return;
        }

        if (event.key === 'Enter' && (this.phone || this.startKeyUp)) {
            this.submit(event);
        }
    }
    },
    mounted() {
        document.addEventListener('keyup', this.handleKeyupEnter);
        LoginResource.getQrCode({ showLoader: true}).then(result => {
            if (result) {
                this.qrcodeUrl = result;
                this.setTotp(result);
            }
        })
    },
    beforeDestroy() {
    document.removeEventListener('keyup', this.handleKeyupEnter);
  }
}
</script>
<style scoped>

h5 {
    border-bottom: 4px solid rgb(0, 38, 119);
}

.microsoft-autenticator {
    text-align: left !important;
}

.info-text {
    font-size: 14px;
    font-family: optum-sans;
    line-height: 20px;
}

.info-account {
    font-family: optum-sans-bold;
    text-align: center;
    font-size: 16px;
    color: rgb(0, 0, 0);
}

</style>